import React, { forwardRef } from "react";
import { motion, HTMLMotionProps } from "framer-motion";

export interface GlassButtonProps extends Omit<HTMLMotionProps<"button">, "ref" | "children"> {
  size?: "sm" | "default" | "lg" | "icon";
  contentClassName?: string;
  children?: React.ReactNode;
}

export const GlassButton = forwardRef<HTMLButtonElement, GlassButtonProps>(
  ({ className = "", size = "default", contentClassName = "", children, ...props }, ref) => {
    
    let padding = "16px 32px";
    let fontSize = "14px";
    
    if (size === "sm") {
       padding = "8px 20px";
       fontSize = "12px";
    } else if (size === "lg") {
       padding = "20px 40px";
       fontSize = "16px";
    } else if (size === "icon") {
       padding = "12px";
       fontSize = "16px";
    }

    return (
      <motion.button
        ref={ref}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        className={className}
        style={{
          position: 'relative',
          overflow: 'hidden',
          borderRadius: '50px',
          background: 'rgba(255, 255, 255, 0.05)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          backdropFilter: 'blur(16px)',
          WebkitBackdropFilter: 'blur(16px)',
          color: '#0f2d5e',
          fontWeight: '900',
          letterSpacing: '0.15em',
          textTransform: 'uppercase',
          padding,
          fontSize,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'border 0.3s ease, background 0.3s ease, box-shadow 0.3s ease',
          boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
          outline: 'none',
          ...props.style
        }}
        onMouseEnter={(e) => {
           e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)';
           e.currentTarget.style.border = '1px solid rgba(255, 255, 255, 0.6)';
           e.currentTarget.style.boxShadow = '0 0 24px rgba(14, 165, 233, 0.4)';
           if (props.onMouseEnter) props.onMouseEnter(e);
        }}
        onMouseLeave={(e) => {
           e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
           e.currentTarget.style.border = '1px solid rgba(255, 255, 255, 0.2)';
           e.currentTarget.style.boxShadow = '0 4px 30px rgba(0, 0, 0, 0.1)';
           if (props.onMouseLeave) props.onMouseLeave(e);
        }}
        {...props}
      >
        <span className={contentClassName} style={{ position: 'relative', zIndex: 10, display: 'flex', alignItems: 'center', gap: '8px' }}>
          {children}
        </span>
      </motion.button>
    );
  }
);

GlassButton.displayName = "GlassButton";
